import gql from 'graphql-tag'

export const UPDATE_MESSAGE = gql`
mutation updateMessage($data: MessagesUpdateInput!, $where: MessagesWhereUniqueInput!){
  updateMessage(data: $data, where: $where) {
    id
  }
}
`
